<template>
  <div class="container">
    <div class="userInfo">
      <div class="userInfo-content">
        <div class="img-content">
          <!-- <div class="cover-text" v-show="user.isReview === 0">
            <div>审核中</div>
          </div> -->
          <img
            style="height: 100%; width: 100%; border-radius: 50%"
            :src="user.photo ? `${apiURL}/image?name=${user.photo}` : none"
            alt
          />
        </div>
        <div v-if="!user.departmentName" style="flex: 1">
          <div style="color: #333; font-size: 18px">{{ user.name }}</div>
          <div style="color: #666; font-size: 15px">
            {{
              (user.label && user.label !== '0') ||
              (user.label && user.label !== 0)
                ? `${user.phone}-${user.label}`
                : user.phone
            }}
          </div>
        </div>
        <div v-else class="info-detail">
          <div class="job">
            <div class="department">{{ user.departmentName }}</div>
            <div class="post">{{ user.job }}</div>
          </div>
          <div class="info">
            <div class="name">{{ user.name }}</div>
            <div class="phone">{{ user.phone }}</div>
          </div>
        </div>
        <div style="height: 24px; height: 24px">
          <img
            style="height: 100%; width: 100%"
            src="@/assets/images/rightImg.png"
            alt
            @click="toPage('PersonInfo')"
          />
        </div>
      </div>
      <!-- <div class="wallet-content">
        <div class="wallet-content-top">
          <span style="font-size: 16px; color: #333">我的钱包</span>
          <img
            style="height: 24px; height: 24px"
            src="@/assets/images/rightImg.png"
            alt
            @click="toPage('UserWallet')"
          />
        </div>
        <CommonBorder></CommonBorder>
        <div class="wallet-content-bottom">
          <div class="bottom-items">
            <div class="items-num">
              {{ (user.balance / 100).toFixed(2) }}
            </div>
            <div class="items-text">现金余额</div>
          </div>
          <div class="bottom-items">
            <div class="items-num">
              {{ (user.allowance / 100).toFixed(2) }}
            </div>
            <div class="items-text">{{ $store.getters.symbolField }}余额</div>
          </div>
          <div class="bottom-items">
            <div class="items-num">
              {{ (user.coupon / 100).toFixed(2) }}
            </div>
            <div class="items-text">优惠余额</div>
          </div>
        </div>
      </div> -->

      <div class="my-wallet">
        <div class="my-wallet-top" @click="toPage('UserWallet')">
          <div class="name">我的钱包</div>
          <img src="@/assets/images/icon-my-wallet-arrow.png" alt="" />
        </div>
        <div class="type">
          <div class="item">
            <div class="type-name">
              <img src="@/assets/images/icon-my-wallet-cash.png" alt="" />
              <span>现金金额</span>
            </div>
            <div class="count">{{ (user.balance / 100).toFixed(2) }}</div>
          </div>
          <div class="item">
            <div class="type-name">
              <img src="@/assets/images/icon-my-wallet-balance.png" alt="" />
              <span>补助金额</span>
            </div>
            <div class="count">{{ (user.allowance / 100).toFixed(2) }}</div>
          </div>
          <div class="item">
            <div class="type-name">
              <img src="@/assets/images/icon-my-wallet-money.png" alt="" />
              <span>优惠余额</span>
            </div>
            <div class="count">{{ (user.coupon / 100).toFixed(2) }}</div>
          </div>
        </div>
      </div>

      <!-- <div class="setting-content">
        <div
          v-for="(item, index) in setting"
          :key="index"
          @click="toPage(item.func)"
        >
          <div class="setting-item">
            <span class="setting-title">
              {{ item.title }}
            </span>
            <img class="setting-img" src="@/assets/images/rightImg.png" alt />
          </div>
          <CommonBorder></CommonBorder>
        </div>
        <div
          v-if="isFreePasswordPay && !isWeixin"
          @click="toPage('PasswordFreeSigning')"
        >
          <div class="setting-item">
            <span class="setting-title">免密签约</span>
            <img class="setting-img" src="@/assets/images/rightImg.png" alt />
          </div>
        </div>
      </div> -->
      <div class="my-service">
        <div class="title">我的服务</div>
        <div class="area">
          <div
            v-for="(item, index) in currentMenus"
            :key="index"
            class="area-item"
            @click="toPage(item.func)"
          >
            <img :src="item.img" alt="" />
            <div class="name">{{ item.title }}</div>
          </div>
          <div
            v-if="setting.length > 7 && !isShowAll"
            class="area-item"
            @click="isShowAll = true"
          >
            <img src="@/assets/images/icon-my-more.png" alt="" />
            <div class="name">更多</div>
          </div>
        </div>
        <div v-if="isShowAll" class="fold" @click="isShowAll = false">
          <span>收起</span>
          <img src="@/assets/images/icon-my-fold.png" alt="" />
        </div>
      </div>
    </div>
    <!-- 底部导航栏 -->
    <van-tabbar v-model="active">
      <van-tabbar-item
        replace
        to="/"
        style="
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          text-align: center;
        "
      >
        <template #icon="props">
          <img
            style="height: 24px; width: 24px; margin-bottom: -10px"
            :src="props.active ? homeChecked : home"
          />
          <span
            :style="props.active ? '  color: #c7000b;' : ' color: #999999;'"
            style="font-size: 10px"
          >
            首页
          </span>
        </template>
      </van-tabbar-item>
      <van-tabbar-item
        replace
        to="/center"
        style="
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          text-align: center;
        "
      >
        <template #icon="props">
          <img
            :src="props.active ? myChecked : my"
            style="height: 24px; width: 24px; margin-bottom: -10px"
          />
          <span
            :style="props.active ? '  color: #c7000b;' : ' color: #999999;'"
            style="font-size: 10px"
          >
            我的
          </span>
        </template>
      </van-tabbar-item>
    </van-tabbar>
    <!-- 联系电话 -->
    <div class="bottom_phone">
      <div>客服电话：028-60656777</div>
    </div>

    <!-- <div
      class="change-user"
      :class="orgs.length === 0 && users.length === 0 ? 'disabled' : ''"
      @click="handleChangeUser"
    >
      <img src="@/assets/images/icon-my-change-user.png" alt="" />

      <span>切换用户</span>
    </div> -->
  </div>
</template>

<script>
import home from '@/assets/images/icon-tabbar-home.png';
import homeChecked from '@/assets/images/icon-home-active.png';
import my from '@/assets/images/icon-tabbar-my.png';
import myChecked from '@/assets/images/icon-tabbar-my-active.png';

import { Swipe, SwipeItem } from 'c-swipe';
import { Toast } from 'vant';
import 'c-swipe/dist/swipe.css';
import mine from '@/assets/mine.png';
import mineActive from '@/assets/mine_active.png';
import homeActive from '@/assets/home_active.png';
import banner3 from '@/assets/banner3.png';
const { VUE_APP_BASE_API } = process.env;
import { getAccInfo } from '@/api/person';
import none from '@/assets/photo_none.png';
import right from '@/assets/right.png';
import faceBind from '@/assets/images/icon-my-face-bind.png';
import pwd from '@/assets/images/icon-my-pwd-setting.png';
import pickSetting from '@/assets/images/icon-my-pick-setting.png';
import familyList from '@/assets/images/icon-my-family.png';
import vehicle from '../../assets/vehicle.png';
import unbind from '@/assets/images/icon-my-unbind.png';
import facebind from '@/assets/images/icon-my-face-bind.png';
import cardManage from '@/assets/images/icon-my-card-manage.png';
import { getUserSystemSetupAPI } from '@/api/family.js';
import healthFood from '@/assets/images/icon-my-health-food.png';
import CommonBorder from '@/components/commonBorder';
import pwdSign from '@/assets/images/icon-my-no-password-sign.png';
export default {
  name: 'Index',
  components: { Swipe, SwipeItem, CommonBorder },
  data() {
    return {
      pwdSign,
      healthFood,
      isShowAll: false,
      pickSetting,
      my,
      homeChecked,
      myChecked,

      faceBind,
      unbind,
      facebind,
      none,
      right,
      logined: true,
      identification: true,
      functionalServices: [],
      active: 1,
      mine,
      home,
      mineActive,
      homeActive,
      // leave,
      index: 0,
      fileList: [],
      banners: [banner3],
      swiperOption: {
        speed: 800,
        loop: true,
        autoplay: {
          delay: 1500,
          disableOnInteraction: false
        }
      },
      loading: false,
      apiURL: process.env.VUE_APP_BASE_API,
      loadImg: false,
      card: '',
      fileImg: '',
      tip: false,
      user: {},
      userId: '',
      phoneShow: false,
      phone: '',
      organizationId: '',
      phones: [],
      orgShow: false,
      orgs: [],
      userShow: false,
      users: [],
      userID: '',
      tuitionPayUrl: `${VUE_APP_BASE_API}/icbc/tuition/pay`,
      infoData: null,
      picUrl: null,
      custID: null,
      showDialog: false,
      centerDialog: true,
      setting: [
        { img: facebind, title: '人脸绑定', func: 'FaceBinding' },
        {
          img: cardManage,
          title: '卡管理',
          func: 'CardManage'
        }
        // { img: unbind, title: "账号解绑", func: "AccUnbundling" },
      ],
      isWeixin: sessionStorage.getItem('weixin'),
      isFreePasswordPay: false
    };
  },
  computed: {
    currentMenus() {
      return this.isShowAll
        ? this.setting
        : this.setting.length > 7
        ? this.setting.slice(0, 7)
        : this.setting;
    }
  },
  async created() {
    this.isFreePasswordPay =
      JSON.parse(
        JSON.parse(sessionStorage.getItem('personInfo')).organization
          .systemSetting
      )?.freePasswordPay?.flag || false;
    if (this.isFreePasswordPay && !this.isWeixin) {
      this.setting.push({
        title: '免密签约',
        func: 'PasswordFreeSigning',
        img: pwdSign
      });
    }
    this.limitSettingFn();
    const { token } = this.$store.getters;
    const { queryEmployee, fetchBanners, getOrg, afterLogin } = this;
    const { phone, custID } = this.$route.query;
    if (!token) {
      if (phone) {
        if (phone.indexOf(',') > -1) {
          const phones = phone.split(',');
          this.phoneShow = true;
          this.phones = phones.map((value) => {
            return { name: value };
          });
        } else {
          this.phone = phone;
          getOrg({ phone });
        }
      } else if (custID) {
        sessionStorage.setItem(
          'custID',
          JSON.stringify(this.$route.query.custID)
        );
        this.$router.push({ name: 'Login', query: { custID } });
      } else {
        afterLogin(false);
      }
    } else {
      queryEmployee();
      fetchBanners();
    }

    if (!sessionStorage.getItem('showDialog')) {
      this.showDialog = true;
    }
    // this.getInfo()
    console.log(sessionStorage.getItem('openid'));
  },
  methods: {
    // 关闭遮罩层
    hideDialog() {
      this.showDialog = false;
      sessionStorage.setItem('showDialog', true);
    },
    // sleep(numberMillis) {
    //   var now = new Date()
    //   var exitTime = now.getTime() + numberMillis
    //   while (true) {
    //     now = new Date()
    //     if (now.getTime() > exitTime) return
    //   }
    // },
    async getInfo() {
      const res = await getAccInfo();
      // console.log(res)
      if (res.code === 0) {
        this.infoData = res.data;
        sessionStorage.setItem('personInfo', JSON.stringify(this.infoData));
      }
    },
    async toInfo() {
      const res = await getAccInfo();
      // this.sleep(2000)
      // console.log(res)
      if (res.code === 0) {
        this.$nextTick(() => {
          this.infoData = res.data;
          // this.picUrl = res.data.photo
          sessionStorage.setItem('personInfo', JSON.stringify(this.infoData));
          // localStorage.setItem('picUrl', JSON.stringify(this.picUrl))
          // this.infoUrl = `${this.apiUrl}/image?name=${this.picUrl}`
        });
        this.$router.push('/personInfo');
      } else {
        // console.log(111)
      }
    },

    async toAccUnbundling() {
      const res = await getAccInfo();
      if (res.code === 0) {
        this.$nextTick(() => {
          this.infoData = res.data;
          console.log(this.infoData, ' this.infoData');
          sessionStorage.setItem('personInfo', JSON.stringify(this.infoData));
        });
        this.$router.push('/accUnbundling');
      } else {
        // console.log(111)
      }
    },

    handler() {
      if (this.fileList.length !== 1) {
        this.$refs.uploader.chooseFile();
      } else {
        this.fileList = [];
        this.$nextTick(() => this.handler());
      }
    },
    handlerImage() {
      if (this.fileList.length !== 1) {
        this.$refs.uploaderImage.chooseFile();
      } else {
        this.fileList = [];
        this.$nextTick(() => this.handlerImage());
      }
    },
    handlerAlbum() {
      if (this.fileList.length !== 1) {
        this.$refs.uploaderAlbum.chooseFile();
      } else {
        this.fileList = [];
        this.$nextTick(() => this.handlerAlbum());
      }
    },
    handlePhoneSelect(item) {
      console.log(item);
      const { getOrg } = this;
      this.phoneShow = false;
      this.phone = item.name;
      getOrg();
    },
    afterLogin(logined) {
      console.log(logined);
      this.logined = logined;
    },
    async fetchBanners() {
      if (JSON.parse(sessionStorage.getItem('banners'))) {
        this.banners = JSON.parse(sessionStorage.getItem('banners'));
      }
    },
    handleOrgSelect(item) {
      const { getUser } = this;
      this.orgShow = false;
      this.organizationId = item.id;
      getUser();
    },
    handleUserSelect(item) {
      console.log(item);
      const { $store, queryEmployee, fetchBanners, afterLogin } = this;
      this.userShow = false;
      $store
        .dispatch('login/login', { userId: item.id })
        .then(() => {
          queryEmployee();
          fetchBanners();
        })
        .catch((err) => {
          afterLogin(false);
          console.log(err);
        });
    },
    queryEmployee() {
      this.loading = true;
      this.$store
        .dispatch('user/getInfo')
        .then((data) => {
          console.log('data', data);
          this.user = data;
          JSON.parse(this.user.organization.systemSetting).freePasswordPay.flag;
          this.fileImg = data.photo;
          this.functionalServices = data.organization.functionalServices
            ? JSON.parse(data.organization.functionalServices)
            : [];
          console.log('functionalServices', this.functionalServices);
          this.loadImg = true;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toPage(name) {
      if (name === 'AccUnbundling') {
        this.toAccUnbundling();
        return;
      }
      this.$router.push({ name });
    },
    onOversize() {
      Toast.fail('照片超出大小，请控制在50M');
    },
    limitSettingFn() {
      if (!localStorage.getItem('openid')) {
        this.setting.push({
          img: unbind,
          title: '账号解绑',
          func: 'AccUnbundling'
        });
      }
      const user = JSON.parse(sessionStorage.getItem('personInfo'));
      if (
        this.$store.getters.menuSetting.children.some(
          (item) => item.meta.title === '智慧食堂'
        )
      ) {
        this.setting.push({
          img: pwd,
          title: '消费密码设置',
          func: 'PwdSetting'
        });
      }

      if (user.classManager && user.classManager.id) {
        this.setting.push({
          img: pickSetting,
          title: '接送信息设置',
          func: 'PickInform'
        });
      }

      if (user.isClassManager) {
        this.setting.push({
          img: healthFood,
          title: '健康饮食',
          func: 'HealthMeal'
        });
      }

      this.getUserSystemSetupFn();
      // if (user.organization.functionalServices.includes(7)) {
      //   this.setting.push({
      //     img: vehicle,
      //     title: "我的车辆",
      //     func: "MyVehicle",
      //   });
      // }

      // if (
      //   this.$store.getters.menuSetting.children
      //     .find((item) => item.name === 'PersonCenterH5')
      //     .children.find((item) => item.name === 'MyVehicle')
      // ) {
      //   this.setting.push({
      //     img: vehicle,
      //     title: '我的车辆',
      //     func: 'MyVehicle'
      //   });
      // }
    },

    async getUserSystemSetupFn() {
      const organizationId = JSON.parse(
        sessionStorage.getItem('personInfo')
      ).organizationId;
      const user = JSON.parse(sessionStorage.getItem('personInfo'));
      const res = await getUserSystemSetupAPI(organizationId);
      if (res.code === 0 && res.data !== null) {
        if (JSON.parse(res.data.setting) !== '{}') {
          if (JSON.parse(res.data.setting).family_set.flag && user.role === 0) {
            this.setting.push({
              img: familyList,
              title: '家属账户',
              func: 'FamilyList'
            });
          }
        }
      }
    }
  }
};
</script>
<style scoped lang="scss">
.my-wallet {
  margin: 0 auto;
  width: 343px;
  height: 132px;
  border-radius: 10px;
  background-image: url('../../assets/images/my-wallet-bg.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center center;
  padding: 0 16px;
  box-sizing: border-box;
  padding-top: 24px;
  display: flex;
  flex-direction: column;
  .my-wallet-top {
    display: flex;
    align-items: center;
    line-height: 1;
    color: #662b13;
    font-size: 16px;
    font-weight: 700;
    img {
      width: 16px;
      height: 16px;
      margin-left: 6px;
    }
  }
  .type {
    margin-top: 25px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .item {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      .type-name {
        display: flex;
        // align-items: center;
        align-items: flex-start;
        color: #5e280b;
        font-size: 12px;
        font-weight: 400;
        line-height: 1;
        img {
          width: 12px;
          height: 12px;
          margin-right: 4px;
        }
      }
      .count {
        color: #5e280b;
        font-size: 18px;
        font-weight: 500;
        line-height: 1;
        margin-top: 13px;
      }
    }
  }
}

.my-service {
  margin: 0 16px;
  background-color: #fff;
  padding: 16px;
  border-radius: 10px;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  box-shadow: 0 5px 15px 0 #00000014;

  .title {
    color: #333333;
    font-size: 16px;
    font-weight: 700;
  }
  .area {
    margin-top: 20px;
    display: flex;
    row-gap: 16px;
    column-gap: 34px;
    flex-wrap: wrap;
    .area-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      gap: 4px;
      img {
        width: 32px;
        height: 32px;
      }
      .name {
        font-family: 'PingFang SC';
        color: #333333;
        font-size: 13px;
        font-weight: 500;
        width: 52px;
        text-align: center;
        line-height: 1;
        overflow: hidden; /* 隐藏超出部分 */
        white-space: nowrap; /* 禁止换行 */
        text-overflow: ellipsis; /* 显示省略号 */
      }
    }
  }
  .fold {
    width: 100%;
    justify-content: center;
    display: flex;
    align-items: center;
    color: #999999;
    font-size: 13px;
    font-weight: 400;
    line-height: 1;
    margin-top: 16px;
    img {
      width: 16px;
      height: 16px;
      margin-left: 6px;
    }
  }
}

.container {
  background-color: #fff;
  height: 100%;
  // .userInfo {
  //   height: 10rem;
  //   width: 100%;
  //   background: rgba(67, 110, 160);
  //   display: flex;
  //   justify-content: space-between;
  //   align-items: center;
  //   .userInfo_left {
  //     display: flex;
  //     .left {
  //       margin: 0 1rem 0 1.5rem;
  //       height: 5rem;
  //       width: 5rem;
  //       overflow: hidden;
  //       border-radius: 0.25rem;
  //       border: 1px solid #cccccc;
  //       position: relative;
  //       .cover-text {
  //         width: 100%;
  //         height: 24px;
  //         border-radius: 12px;
  //         background: #517efd;
  //         color: #fff;
  //         text-align: center;
  //         position: absolute;
  //         font-size: 12px;
  //         top: 3.4rem;
  //         left: -1.5rem;
  //         z-index: 9999;
  //         transform: rotate(45deg);
  //         div {
  //           width: 100%;
  //           position: absolute;
  //           top: 0;
  //           left: 0;
  //         }
  //       }
  //       img {
  //         width: 100%;
  //         height: 100%;
  //       }
  //     }
  //     .right {
  //       color: white;
  //     }
  //   }
  //   .userInfo_right {
  //     padding-right: 1rem;
  //     img {
  //       width: 2.5rem;
  //     }
  //   }
  // }
  // .userInfo_wallet {
  //   width: 95%;
  //   height: 8rem;
  //   margin: 0 auto;
  //   background: rgba(255, 255, 255);
  //   border-radius: 1rem;
  //   .userInfo_wallet_top {
  //     margin-top: 1rem;
  //     height: 2rem;
  //     display: flex;
  //     justify-content: space-between;
  //     font-size: 1.3rem;
  //     color: rgba(0, 0, 0, 0.9);
  //     p {
  //       margin: 0;
  //       font-weight: 700;
  //       margin-top: 0.5rem;
  //     }
  //     p:nth-child(1) {
  //       margin-left: 1rem;
  //     }
  //     p:nth-child(2) {
  //       margin-right: 1rem;
  //     }
  //   }
  //   .userInfo_wallet_bottom {
  //     width: 95%;
  //     display: flex;
  //     margin: auto;
  //     text-align: center;
  //     li {
  //       width: 25%;
  //       p:nth-child(1) {
  //         overflow: hidden;
  //         white-space: nowrap;
  //         text-overflow: ellipsis;
  //         font-size: 1rem;
  //       }
  //       p:nth-child(2) {
  //         font-size: 0.75rem;
  //       }
  //     }
  //   }
  // }
  // .userInfo_setting {
  //   width: 95%;
  //   padding-bottom: 1rem;
  //   margin: 0 auto;
  //   background: rgba(255, 255, 255);
  //   border-radius: 1rem;
  //   .userInfo_setting_top {
  //     margin-top: 1rem;
  //     height: 2rem;
  //     display: flex;
  //     justify-content: space-between;
  //     font-size: 1.3rem;

  //     color: rgba(0, 0, 0, 0.9);
  //     p {
  //       margin: 0;
  //       font-weight: 700;
  //       margin-top: 0.5rem;
  //     }
  //     p:nth-child(1) {
  //       margin-left: 1rem;
  //     }
  //     p:nth-child(2) {
  //       margin-right: 1rem;
  //     }
  //   }
  //   .userInfo_setting_bottom {
  //     width: 95%;
  //     display: flex;
  //     margin: auto;
  //     text-align: center;
  //     flex-wrap: wrap;
  //     li {
  //       width: 25%;
  //       p:nth-child(1) {
  //         margin: 0;
  //         margin-top: 1rem;
  //         img {
  //           width: 50%;
  //         }
  //       }
  //       p:nth-child(2) {
  //         margin: 0;
  //         font-size: 0.75rem;
  //       }
  //     }
  //   }
  // }
  // .bottom_phone {
  //   width: 100%;
  //   text-align: center;
  //   position: fixed;
  //   bottom: 5rem;
  //   color: black;
  //   font-size: 0.9rem;
  //   div {
  //     width: 80%;
  //     margin: 0 auto;
  //     text-align: center;
  //   }
  // }
  .userInfo {
    .userInfo-content {
      background: #fff;
      display: flex;
      flex-direction: row;
      align-items: center;
      box-sizing: border-box;
      padding: 24px 16px 20px;
      .img-content {
        height: 55px;
        width: 55px;
        margin-right: 12px;
        position: relative;
        overflow: hidden;
        border-radius: 50%;
      }
      .info-detail {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex: 1;
        height: 41px;
        .job,
        .info {
          display: flex;
        }
        .job {
          line-height: 18px;

          .department {
            color: #333333;
            font-size: 18px;
            font-weight: 500;
          }
          .post {
            color: #666666;
            font-size: 18px;
            font-weight: 400;
            margin-left: 16px;
          }
        }
        .info {
          line-height: 15px;
          color: #333333;
          font-size: 15px;
          font-weight: 400;
          .phone {
            margin-left: 8px;
          }
        }
      }
    }
    .wallet-content {
      background: #fff;
      margin-top: 15px;
      .wallet-content-top {
        box-sizing: border-box;
        padding: 10px 16px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
      }
      .wallet-content-bottom {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 16px;
        .bottom-items {
          width: 33%;
          text-align: center;
          .items-num {
            font-size: 17px;
            color: #333333;
            margin-bottom: 10px;
          }
          .items-text {
            font-size: 14px;
            color: #999999;
          }
        }
      }
    }
    .setting-content {
      background: #fff;
      margin-top: 15px;
      .setting-item {
        box-sizing: border-box;
        padding: 10px 16px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        .setting-title {
          font-size: 16px;
          color: #666;
        }
        .setting-img {
          height: 24px;
          height: 24px;
        }
      }
    }
  }
  .bottom_phone {
    width: 100%;
    text-align: center;
    color: #b2b2b2;
    font-size: 13px;
    line-height: 20px;
    margin-top: 30px;
    padding-bottom: 120px;
    div {
      width: 72%;
      margin: 0 auto;
      text-align: center;
    }
  }
}
</style>
